import { render, staticRenderFns } from "./geneVariation.vue?vue&type=template&id=4c4db0e1&scoped=true"
import script from "./geneVariation.vue?vue&type=script&lang=js"
export * from "./geneVariation.vue?vue&type=script&lang=js"
import style0 from "./geneVariation.vue?vue&type=style&index=0&id=4c4db0e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4db0e1",
  null
  
)

export default component.exports